





















































































































































































































import { Component, Vue } from "vue-property-decorator";

import { ContractsModule } from "@/store/contracts.module";
import { UsersManagementModule } from "@/store/users-management.module";
import { UsersManagementService } from "@/services/api/users-management.service";
import { AuthModule } from "@/store/auth.module";
import { translate } from "@/utils";

import UserFormModal from "@/components/profile/UserFormModal.vue";
import UserEmailConfirmationDialog from "@/components/profile/UserEmailConfirmationDialog.vue";
import ConfirmDialog from "@/components/ui/ConfirmDialog.vue";

import SvgIcon from "@/components/ui/SvgIcon.vue";

@Component({
  components: {
    UserFormModal,
    UserEmailConfirmationDialog,
    ConfirmDialog,
    SvgIcon,
  },
})
export default class UserPage extends Vue {
  $refs: {
    confirmStatusChange: ConfirmDialog;
  };
  loading: boolean = true;
  contractsLoading: boolean = true;

  emailDialog: boolean = false;
  editUserModalDialog: boolean = false;

  tempUser: any = {};
  tempContracts: any = [];
  userActive: boolean = false;

  created() {
    this.getUserInfo();
  }

  async onStatusChange(newStatus: boolean) {
    if (this.loading) return;
    const confrimed = await this.$refs.confirmStatusChange.show();

    if (confrimed) {
      this.userActive = newStatus;
      await UsersManagementService.updateUserStatus(
        this.user.record_id,
        newStatus,
      );
      this.getUserInfo();
    } else {
      this.userActive = !newStatus;
    }
  }

  get statusChangeText() {
    const user =
      this.user.last_name +
      " " +
      this.user.first_name +
      (this.user?.middle_name ? " " + this.user?.middle_name : "");

    if (this.user.active) {
      return this.$t("profile.users_management.confirmation.block", {
        user,
        email: this.user.user_email,
      });
    } else {
      return this.$t("profile.users_management.confirmation.unblock", { user });
    }
  }

  get isMe() {
    const me = AuthModule.user;
    return me?.record_id === this.tempUser.record_id;
  }

  async getUserInfo() {
    this.loading = true;
    this.contractsLoading = true;

    this.tempUser = await UsersManagementService.getUserInfo(
      this.$route.params.user_rid,
    );
    await (this.userActive = this.tempUser.active);
    this.loading = false;

    this.tempContracts = await UsersManagementModule.getUserContracts(
      this.$route.params.user_rid,
    );
    this.contractsLoading = false;

    const test = await UsersManagementService.getOrganizationContracts(
      this.orgUser.org_rid,
    );
  }

  get orgUser() {
    return AuthModule.user as IUser;
  }

  get user() {
    const temp = this.tempUser;
    const user = translate(temp);
    return user;
  }

  get contracts() {
    const contracts = translate(this.tempContracts);
    return contracts;
  }

  onEditUser() {
    if (this.loading || this.contractsLoading) return;
    this.editUserModalDialog = true;
  }

  clickContract(id: number) {
    ContractsModule.selectContractAndRoute(id);
  }
}
